import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { environment } from '@teem/environments/environment';


@Component({
  selector: 'app-invoice-qr-code-modal',
  templateUrl: './invoice-qr-code-modal.component.html',
  styles: []
})
export class InvoiceQrCodeModalComponent implements OnInit {

  @Input() invoiceUrl;
  invResponse: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private loaderService: LoaderService) {
  }

  ngOnInit() {
    if(this.invoiceUrl){
      this.invResponse = { 'url' : `${this.invoiceUrl}`};
    }
  }
  
}
